export default "__VITE_ASSET__CcA1ojgA__";